<template>
  <div class="assignments-section">
    <div class="assignments__body">
      <v-form ref="assignments" class="assignments__main-form">
        <v-row class="row">
          <v-col cols="1" class="d-flex align-center">
            <div class="assignments__summ">{{ assignmentsList.length }}</div>
          </v-col>
          <v-col cols="2" class="d-flex align-center">
            <h2>
             Assignments
            </h2>
          </v-col>
          <v-col cols="2" class="d-flex align-center">
            <v-autocomplete
              filled
              label="Group By"
              :items="groupByOptions"
              v-model="groupByAssignments"
              hide-details
            ></v-autocomplete>
          </v-col>
          <v-col cols="4" class="d-flex align-center">
            <v-autocomplete
              filled
              :items="pricingModelOptions"
              v-model="pricingModel"
              label="Pricing Model"
              hide-details
            ></v-autocomplete>
          </v-col>
          <v-col cols="3" class="d-flex justify-end">
            <v-menu 
              rounded="lg"
              transition="slide-y-transition"
              offset-y>
              <template v-slot:activator="{ on, attrs }">
                <button
                  v-bind="attrs"
                  v-on="on"
                  class="assignments__dropdown-button"
                  @click.prevent="showAssignmentsDropdown = !showAssignmentsDropdown"
                >
                  <v-icon>mdi-dots-horizontal</v-icon>
                </button>
              </template>
              <v-list>
                <v-list-item 
                  class="wtMenuList__item"
                  @click.prevent="batchEditDialog = true">
                  <v-list-item-title>Set field value [batch]</v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="wtMenuList__item"
                  @click.prevent="$emit('open-assignments-fields-modal')"
                >
                  <v-list-item-title>Tweak shared / overridden fields</v-list-item-title>
                </v-list-item>
                <v-list-item 
                  class="wtMenuList__item"
                  @click.prevent="addNewAssignment">
                  <v-list-item-title>Add new assignment</v-list-item-title>
                </v-list-item>
                <v-list-item 
                  class="wtMenuList__item"
                  @click.prevent="foldAllGroups">
                  <v-list-item-title>Fold all groups</v-list-item-title>
                </v-list-item>
                <v-list-item 
                  class="wtMenuList__item"
                  @click.prevent="unfoldAllGroups">
                  <v-list-item-title>Unfold all groups</v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="wtMenuList__item"
                  @click.prevent="foldAllAssignmentCards">
                  <v-list-item-title>Fold all assignment cards</v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="wtMenuList__item"
                  @click.prevent="unfoldAllAssignmentCards">
                  <v-list-item-title>Unfold all assignment cards</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <v-row class="row group" 
          :style="{'padding-bottom': assignmentItem.expanded ? '20px' : '0'}"
          v-for="assignmentItem in groupedAssignmentsList"
          :key="assignmentItem.key">
          <v-col cols="12" class="px-0">
            <v-row class="row clickable-row" @click="assignmentItem.expanded = !assignmentItem.expanded">
              <v-col cols="1" class="d-flex align-center justify-center">
                <div class="group__summ">{{ assignmentItem.items.length }}</div>
              </v-col>
              <v-col cols="4" class="d-flex align-center">
                <div class="group__geo">{{ assignmentItem.label || assignmentItem.key }}</div>
              </v-col>
              <v-col cols="7" class="d-flex justify-end">
                <button
                  class="group__dropdown-button"
                  @click.stop.prevent="assignmentItem.expanded = !assignmentItem.expanded"
                >
                  <v-icon :class="{ 'rotated': assignmentItem.expanded }">mdi-chevron-down</v-icon>
                </button>
              </v-col>
            </v-row>
            <transition name="fade-slide">
              <v-row class="row" 
                v-show="assignmentItem.expanded">
                <v-col cols="12" class="pa-1">
                  <v-row class="row assignment-container mx-1 mb-2" 
                    v-for="(item, index) in assignmentItem.items"
                    :key="item.togglerId ?? index">
                    <v-col cols="12" class="pa-0">
                        <v-row class="row p-10px clickable-row" @click="item.togglerState = !item.togglerState">
                          <v-col cols="10" class="d-flex align-center pa-0">
                            <p class="assignment-item__title mb-0">Assignment {{ getAssignmentDisplayNumber(item) }}</p>
                          </v-col>
                          <v-col cols="1" class="py-0 d-flex justify-end align-center">
                            <v-menu 
                              rounded="lg"
                              transition="slide-y-transition"
                              offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <button
                                  v-bind="attrs"
                                  v-on="on"
                                  class="assignees__dropdown-button"
                                  @click.stop.prevent="item.to = !showAssignmentsDropdown"
                                >
                                  <v-icon>mdi-dots-horizontal</v-icon>
                                </button>
                              </template>
                              <v-list>
                                <v-list-item 
                                  class="wtMenuList__item"
                                  @click.prevent="duplicateAssignment(item)">
                                  <v-list-item-title>Duplicate assignment</v-list-item-title>
                                </v-list-item>
                                <v-list-item 
                                  class="wtMenuList__item"
                                  @click.prevent="deleteAssignment(item)">
                                  <v-list-item-title>Delete assignment</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-col>
                          <v-col cols="1" class="py-0 d-flex justify-center align-center">
                            <button
                              class="group__dropdown-button"
                              @click.stop.prevent="item.togglerState = !item.togglerState"
                            >
                              <v-icon :class="{ 'rotated': item.togglerState }" style="margin-bottom: 5px;">mdi-chevron-down</v-icon>
                            </button>
                          </v-col>
                        </v-row>
                      </v-col>
                    <v-row class="row assignment-item" 
                      v-show="item.togglerState">
                      <v-col cols="12" class="pa-0">
                        <v-row class="row">
                          <v-col cols="12" v-if="isFieldIndividual('assignmentTitle')">
                            <v-text-field
                              filled
                              label="Assignment Title"
                              hide-details
                              :value="item.assignmentTitle"
                              @input="item.assignmentTitle = $event"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="row">
                          <v-col cols="12" v-if="isFieldIndividual('assignmentDetail')">
                            <v-text-field
                              filled
                              label="Assignment Detail"
                              hide-details
                              :value="item.assignmentDetail"
                              @input="item.assignmentDetail = $event"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="row">
                          <v-col cols="12" v-if="isFieldIndividual('requestType')">
                            <v-autocomplete
                              filled
                              label="Request Type"
                              :items="requestTypeOptions"
                              v-model="item.requestType"
                              @change="handleAssignmentWorkflowCriteriaChange()"
                              hide-details
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row class="row">
                          <v-col cols="12" v-if="isFieldIndividual('geo')">
                            <v-autocomplete
                              filled
                              label="GEO"
                              :items="geoOptions"
                              v-model="item.geo"
                              @change="handleAssignmentWorkflowCriteriaChange()"
                              hide-details
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row class="row">
                          <v-col cols="12" v-if="isFieldIndividual('assignmentId')">
                            <v-combobox
                              filled
                              label="ID"
                              v-model="item.assignmentId"
                              hide-details
                            ></v-combobox>
                          </v-col>
                        </v-row>
                        <v-row class="row">
                          <v-col cols="12" class="pb-0 flex">
                            <p class="assignment-item__title mb-0">Assignees</p>
                            <div class="flex ml-3 align-center">
                              <v-menu 
                                rounded="lg"
                                transition="slide-y-transition"
                                offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                  <button
                                    v-bind="attrs"
                                    v-on="on"
                                    class="assignees__dropdown-button"
                                    @click.prevent="showAssignmentsDropdown = !showAssignmentsDropdown"
                                  >
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                  </button>
                                </template>
                                <v-list>
                                  <v-list-item 
                                    class="wtMenuList__item"
                                    @click.prevent="applySectionFieldsToGroup(item, assigneeSectionFields)">
                                    <v-list-item-title>Apply to assignments in this group ({{ getCurrentGroupAssignmentsCount(item) }})</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item 
                                    class="wtMenuList__item"
                                    @click.prevent="
                                      applySectionFields(
                                        item,
                                        allAssignments,
                                        assigneeSectionFields
                                      )
                                    ">
                                    <v-list-item-title>Apply to all assignments ({{ totalAssignmentsCount }})</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </div>
                          </v-col>
                        </v-row>
                        <v-row class="row">
                          <v-col cols="12" sm="4" class="pb-0 anounce-text-container">
                            <div class="assignee-input-wrapper">
                              <v-autocomplete
                                :key="`primary-${item.togglerId}-${uiRefreshNonce}`"
                                label="Primary"
                                filled
                                hide-details
                                return-object
                                item-text="name"
                                item-value="id"
                                :items="item?.staffPool?.primary || []"
                                v-model="item.primaryAssignee"
                              >
                              <template v-slot:item="data">
                                <template>
                                  <v-list-item-content>
                                    <v-list-item-title class="d-flex align-center justify-space-between">
                                      <v-badge
                                        v-if="data.item.workflow && data.item.totalAllowedWords - data.item.usedWords > 1200"
                                        class="mt-0 mb-1 mr-2"
                                        inline
                                        color="green"
                                        dot
                                      ></v-badge>
                                      <v-badge
                                        v-if="data.item.workflow 
                                          && data.item.totalAllowedWords - data.item.usedWords <= 1200
                                          && data.item.totalAllowedWords - data.item.usedWords > 0"
                                        class="mt-0 mb-1 mr-2"
                                        inline
                                        color="orange"
                                        dot
                                      ></v-badge>
                                      <v-badge
                                        v-if="data.item.workflow && data.item.totalAllowedWords - data.item.usedWords <= 0"
                                        class="mt-0 mb-1 mr-2"
                                        inline
                                        color="red"
                                        dot
                                      ></v-badge>
                                      {{ data.item.name || data.item.header }}
                                      <v-list-item-subtitle
                                        v-if="data.item.lastDeliveryDaysAgo"
                                        class="ml-3">
                                        {{ data.item.totalAllowedWords ? (data.item.totalAllowedWords - data.item.usedWords) : `0` }} words left
                                        {{ `  |  ${Math.abs(data.item.lastDeliveryDaysAgo)} d ago` }}
                                      </v-list-item-subtitle>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </template>
                              </template>
                            </v-autocomplete>
                            <v-tooltip
                              v-if="hasAssigneeWarning('primary', item)"
                              top
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  class="assignee-warning-overlay"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <img
                                    class="assignee-warning-icon"
                                    src="@/assets/icons/assignee-warning.svg"
                                    alt="warning"
                                  />
                                </span>
                              </template>
                              <span>{{ autocompleteWarning('primary', item) }}</span>
                            </v-tooltip>
                          </div>
                          </v-col>
                          <v-col cols="12" sm="4" class="pb-0 anounce-text-container">
                            <div class="assignee-input-wrapper">
                              <v-autocomplete
                                :key="`secondary-${item.togglerId}-${uiRefreshNonce}`"
                                label="Secondary"
                                filled
                                hide-details
                                return-object
                                item-text="name"
                                item-value="id"
                                :items="item?.staffPool?.secondary || []"
                                v-model="item.secondaryAssignee"
                              >
                              <template v-slot:item="data">
                                <template>
                                  <v-list-item-content>
                                    <v-list-item-title class="d-flex align-center justify-space-between">
                                      <v-badge
                                        v-if="data.item.workflow && data.item.totalAllowedWords - data.item.usedWords > 1200"
                                        class="mt-0 mb-1 mr-2"
                                        inline
                                        color="green"
                                        dot
                                      ></v-badge>
                                      <v-badge
                                        v-if="data.item.workflow 
                                          && data.item.totalAllowedWords - data.item.usedWords <= 1200
                                          && data.item.totalAllowedWords - data.item.usedWords > 0"
                                        class="mt-0 mb-1 mr-2"
                                        inline
                                        color="orange"
                                        dot
                                      ></v-badge>
                                      <v-badge
                                        v-if="data.item.workflow && data.item.totalAllowedWords - data.item.usedWords <= 0"
                                        class="mt-0 mb-1 mr-2"
                                        inline
                                        color="red"
                                        dot
                                      ></v-badge>
                                      {{ data.item.name || data.item.header }}
                                      <v-list-item-subtitle
                                        v-if="data.item.lastDeliveryDaysAgo"
                                        class="ml-3">
                                        {{ data.item.totalAllowedWords ? (data.item.totalAllowedWords - data.item.usedWords) : `0` }} words left
                                        {{ `  |  ${Math.abs(data.item.lastDeliveryDaysAgo)} d ago` }}
                                      </v-list-item-subtitle>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </template>
                              </template>
                              </v-autocomplete>
                              <v-tooltip
                                v-if="hasAssigneeWarning('secondary', item)"
                                top
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <span
                                    class="assignee-warning-overlay"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <img
                                      class="assignee-warning-icon"
                                      src="@/assets/icons/assignee-warning.svg"
                                      alt="warning"
                                    />
                                  </span>
                                </template>
                                <span>{{ autocompleteWarning('secondary', item) }}</span>
                              </v-tooltip>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="4" class="pb-0 anounce-text-container">
                            <div class="assignee-input-wrapper">
                              <v-autocomplete
                                :key="`qc-${item.togglerId}-${uiRefreshNonce}`"
                                label="QC"
                                filled
                                hide-details
                                return-object
                                item-text="name"
                                item-value="id"
                                :items="item?.staffPool?.qc || []"
                                v-model="item.qcAssignee"
                              >
                              <template v-slot:item="data">
                                <template>
                                  <v-list-item-content>
                                    <v-list-item-title class="d-flex align-center justify-space-between">
                                      <v-badge
                                        v-if="data.item.workflow && data.item.totalAllowedWords - data.item.usedWords > 1200"
                                        class="mt-0 mb-1 mr-2"
                                        inline
                                        color="green"
                                        dot
                                      ></v-badge>
                                      <v-badge
                                        v-if="data.item.workflow 
                                          && data.item.totalAllowedWords - data.item.usedWords <= 1200
                                          && data.item.totalAllowedWords - data.item.usedWords > 0"
                                        class="mt-0 mb-1 mr-2"
                                        inline
                                        color="orange"
                                        dot
                                      ></v-badge>
                                      <v-badge
                                        v-if="data.item.workflow && data.item.totalAllowedWords - data.item.usedWords <= 0"
                                        class="mt-0 mb-1 mr-2"
                                        inline
                                        color="red"
                                        dot
                                      ></v-badge>
                                      {{ data.item.name || data.item.header }}
                                      <v-list-item-subtitle
                                        v-if="data.item.lastDeliveryDaysAgo"
                                        class="ml-3">
                                        {{ data.item.totalAllowedWords ? (data.item.totalAllowedWords - data.item.usedWords) : `0` }} words left
                                        {{ `  |  ${Math.abs(data.item.lastDeliveryDaysAgo)} d ago` }}
                                      </v-list-item-subtitle>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </template>
                              </template>
                              </v-autocomplete>
                              <v-tooltip
                                v-if="hasAssigneeWarning('qc', item)"
                                top
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <span
                                    class="assignee-warning-overlay"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <img
                                      class="assignee-warning-icon"
                                      src="@/assets/icons/assignee-warning.svg"
                                      alt="warning"
                                    />
                                  </span>
                                </template>
                                <span>{{ autocompleteWarning('qc', item) }}</span>
                              </v-tooltip>
                            </div>
                          </v-col>
                        </v-row>
                        <v-row class="row">
                          <v-col cols="12" sm="4" class="pb-0 mt-0 ">
                            <v-checkbox
                              v-model="item.individualDeadline"
                              label="Individual Deadline"
                              hide-details
                              class="my-2"
                              @change="onDeadlineChange($event, item)"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                        <transition name="fade-slide">
                          <div v-if="item.individualDeadline">
                            <v-row class="row mt-3">
                              <v-col cols="4">
                                <v-menu
                                  v-model="item.primaryDateTimeMenu"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      :value="generalDateTimeFormatter(
                                        item.writingDueDate ? item.writingDueDate : formValues.defaultDeliveryDate, 
                                        item.writingDue ? item.writingDue : formValues.defaultDeliveryDue
                                        )"
                                      label="Primary Due Date / Time (ET)"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      hide-details
                                      filled
                                    ></v-text-field>
                                  </template>
                                  <CustomDateTimePicker 
                                    :preparedDate="item.writingDueDate" 
                                    :preparedTime="item.writingDue"
                                    @onDateSelected="assignmentIndividualDateSelected('primary', item, $event)"
                                    @onTimeSelected="assignmentIndividualTimeSelected('primary', item, $event)"/>
                                </v-menu>
                              </v-col>
                              <v-col cols="4">
                                <v-menu
                                  v-model="secondaryDateTimeMenu"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      :value="generalDateTimeFormatter(
                                        item.editingDueDate ? item.editingDueDate : formValues.editingDueDate, 
                                        item.editingDue ? item.editingDue : formValues.editingDue
                                        )"
                                      label="Secondary Due Date / Time (ET)"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      hide-details
                                      filled
                                    ></v-text-field>
                                  </template>
                                  <CustomDateTimePicker 
                                    :preparedDate="item.editingDueDate" 
                                    :preparedTime="item.editingDue"
                                    @onDateSelected="assignmentIndividualDateSelected('secondary', item, $event)"
                                    @onTimeSelected="assignmentIndividualTimeSelected('secondary', item, $event)"/>
                                </v-menu>
                              </v-col>
                              <v-col cols="4">
                                <v-menu
                                  v-model="qcDateTimeMenu"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      :value="generalDateTimeFormatter(
                                        item.reviewingDueDate ? item.reviewingDueDate : formValues.reviewingDueDate, 
                                        item.reviewingDue ? item.reviewingDue : formValues.reviewingDue
                                        )"
                                      label="QC Due Date / Time (ET)"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      hide-details
                                      filled
                                    ></v-text-field>
                                  </template>
                                  <CustomDateTimePicker 
                                    :preparedDate="item.reviewingDueDate" 
                                    :preparedTime="item.reviewingDue"
                                    @onDateSelected="assignmentIndividualDateSelected('qc', item, $event)"
                                    @onTimeSelected="assignmentIndividualTimeSelected('qc', item, $event)"/>
                                </v-menu>
                              </v-col>
                            </v-row>
                            <v-row class="row mt-3">
                              <v-col cols="12">
                                <v-menu
                                  v-model="primaryDateTimeMenu"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      :value="generalDateTimeFormatter(
                                        item.deliveryDate ? item.deliveryDate : formValues.deliveryDate,
                                        item.deliveryDue ? item.deliveryDue : formValues.deliveryDue
                                      )"
                                      label="Delivery Date / Time (ET)"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      hide-details
                                      filled
                                    ></v-text-field>
                                  </template>
                                  <CustomDateTimePicker 
                                    :preparedDate="item.deliveryDate" 
                                    :preparedTime="item.deliveryDue"
                                    @onDateSelected="assignmentIndividualDateSelected('delivery', item, $event)"
                                    @onTimeSelected="assignmentIndividualTimeSelected('delivery', item, $event)"/>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </div>
                        </transition>
                        <v-row class="row" v-if="!shakespeareLoc && !cueLoc">
                          <v-col cols="12" class="pb-0 flex">
                            <p class="assignment-item__title my-2">Assignment Work Types & Work Quantity</p>
                            <div class="flex ml-3 align-center">
                              <v-menu 
                                rounded="lg"
                                transition="slide-y-transition"
                                offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                  <button
                                    v-bind="attrs"
                                    v-on="on"
                                    class="assignees__dropdown-button"
                                    @click.prevent="showAssignmentsDropdown = !showAssignmentsDropdown"
                                  >
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                  </button>
                                </template>
                                <v-list>
                                  <v-list-item 
                                    class="wtMenuList__item"
                                    @click.prevent="applySectionFieldsToGroup(item, workTypesSectionFields)">
                                    <v-list-item-title>Apply to assignments in this group ({{ getCurrentGroupAssignmentsCount(item) }})</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item 
                                    class="wtMenuList__item"
                                    @click.prevent="
                                      applySectionFields(
                                        item,
                                        allAssignments,
                                        workTypesSectionFields
                                      )
                                    ">
                                    <v-list-item-title>Apply to all assignments ({{ totalAssignmentsCount }})</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </div>
                          </v-col>
                        </v-row>
                        <div v-if="isFcLocalizationPricingModel">
                          <v-row class="row">
                            <v-col cols="6">
                              <v-autocomplete
                                class="py-1"
                                :label="`Work Type 1 Reference`"
                                hide-details
                                filled
                                :items="getLocReferencesOptions(1, item.geo)"
                                :value="getWorkTypeValue(item, `workType1Reference`)"
                                @change="(v) => handleValueSelectChange( `workType1Reference`, v, item )"
                              ></v-autocomplete>
                            </v-col>
                            <v-col
                              cols="6"
                              v-if="pricingModel === 'FC Localization: Combined (Per Word + Per Unit)'"
                            >
                              <v-autocomplete
                                class="py-1"
                                :label="`Work Type 2 Reference`"
                                hide-details
                                filled
                                :items="getLocReferencesOptions(2, item.geo)"
                                :value="getWorkTypeValue(item, `workType2Reference`)"
                                @change="(v) => handleValueSelectChange( `workType2Reference`, v, item )"
                              ></v-autocomplete>
                            </v-col>
                            <v-col
                              cols="6"
                              v-if="pricingModel !== 'FC Localization: Per Unit' && pricingModel !== 'FC Localization: Combined (Per Word + Per Unit)'"
                            >
                              <v-text-field
                                class="py-1"
                                label="Word Count"
                                type="number"
                                hide-details
                                filled
                                :value="item.workType1Quantity"
                                @change="(v) => handleValueSelectChange( `workType1Quantity`, v, item )"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="3"
                              v-if="pricingModel === 'FC Localization: Per Unit'"
                            >
                              <v-text-field
                                class="py-1"
                                label="Unit Count"
                                type="number"
                                hide-details
                                filled
                                :value="item.workType1Quantity"
                                @change="(v) => handleValueSelectChange( `workType1Quantity`, v, item )"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="3"
                              v-if="pricingModel === 'FC Localization: Per Unit'"
                            >
                              <v-text-field
                                class="py-1"
                                label="Character Count"
                                type="number"
                                hide-details
                                filled
                                :value="item.characterCount"
                                @change="(v) => handleValueSelectChange( `characterCount`, v, item )"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row
                            class="row"
                            v-if="pricingModel === 'FC Localization: Combined (Per Word + Per Unit)'"
                          >
                            <v-col cols="6">
                              <v-text-field
                                class="py-1"
                                label="Word Count"
                                type="number"
                                hide-details
                                filled
                                :value="item.workType1Quantity"
                                @change="(v) => handleValueSelectChange( `workType1Quantity`, v, item )"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                class="py-1"
                                label="Unit Count"
                                type="number"
                                hide-details
                                filled
                                :value="item.workType2Quantity"
                                @change="(v) => handleValueSelectChange( `workType2Quantity`, v, item )"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                class="py-1"
                                label="Character Count"
                                type="number"
                                hide-details
                                filled
                                :value="item.characterCount"
                                @change="(v) => handleValueSelectChange( `characterCount`, v, item )"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </div>
                        <div v-else-if="isNonFcPricingModel">
                          <v-row class="row">
                            <v-col cols="12" sm="6">
                              <v-combobox
                                class="py-2"
                                label="Work Type"
                                hide-details
                                filled
                                :value="item.workType1Reference"
                                @change="(v) => handleValueSelectChange( `workType1Reference`, v, item )"
                              ></v-combobox>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                class="py-2"
                                label="Quantity"
                                type="number"
                                hide-details
                                filled
                                :value="item.workType1Quantity"
                                @change="(v) => handleValueSelectChange( `workType1Quantity`, v, item )"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row class="row">

                          </v-row>
                        </div>
                        <div v-else-if="isFcCopywritingPricingModel">
                          <v-row class="row">
                            <v-col v-for="i in [1, 2, 3, 4, 5, 6]" :key="i" cols="12" sm="2">
                              <v-autocomplete
                                class="py-2"
                                :label="`Work Type ${i} Reference`"
                                :items="getReferencesOptions(i, item.geo)"
                                :value="getWorkTypeValue(item, `workType${i}Reference`)"
                                @change="(v) => handleValueSelectChange( `workType${i}Reference`, v, item )"
                                :clearable="i !== 1"
                                hide-details
                                filled
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row class="row">
                            <v-col v-for="i in [1, 2, 3, 4, 5, 6]" :key="i" cols="12" sm="2">
                              <v-text-field
                                class="py-2"
                                :label="`Work Type ${i} Quantity`"
                                type="number"
                                :value="item[`workType${i}Quantity`]"
                                :clearable="i !== 1"
                                hide-details
                                @change="(v) => handleValueSelectChange( `workType${i}Quantity`, v, item )"
                                filled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                    </v-row>
                  </v-row>
                </v-col>
              </v-row>
            </transition>
          </v-col>
        </v-row>
        <v-row class="row">
          <v-col cols="12">
            <CapacitySection />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <v-dialog
      transition="dialog-top-transition"
      max-width="466px"
      v-model="batchEditDialog"
      @click:outside="closeBatchEditDialog"
      @keydown.esc="closeBatchEditDialog"
    >
      <v-card class="d-flex flex-column flex-wrap pa-4 dialog-card">
        <v-row>
          <v-col cols="12">
            <h3>Set field value for all assignments (batch)</h3>
          </v-col>

          <v-col cols="12" class="mt-4">
            <v-autocomplete
              filled
              label="Field name"
              :items="filedNames.map((f) => f.title)"
              v-model="batchEdit.fieldName"
              hide-details
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" class="my-4">
            <v-autocomplete
              v-if="isBatchFieldSelect"
              filled
              label="Field Value"
              :items="fieldValues"
              v-model="batchEdit.fieldValue"
              hide-details
            ></v-autocomplete>
            <v-text-field
              v-else
              filled
              label="Field Value"
              :type="batchFieldInputType"
              hide-details
              v-model="batchEdit.fieldValue"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-card-actions class="justify-end mt-4">
          <v-btn depressed @click="closeBatchEditDialog">Cancel</v-btn>
          <v-btn color="#1976D2" class="white--text" @click="applyBatchEdit">Set</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  getEnum,
  getStaffWithWorkflows,
  getWorkflofsByProject
} from "@/utils/newDbUtils";
import { isAdaptation, getFCWorkType } from "@/utils/spreadsheetUploadUtils";
import CustomDateTimePicker from "@/components/ui/CustomDateTimePicker.vue";
import CapacitySection from "./CapacitySection.vue";
import { iTunesWorkTypeReference } from "@/utils/spreadsheetUploadUtils";
import { cloneDeep } from "lodash";

const PRICING_MODEL_OPTIONS = {
  FC_LOCALIZATION_PER_WORD: "FC Localization: Per Word",
  FC_LOCALIZATION_PER_UNIT: "FC Localization: Per Unit",
  FC_LOCALIZATION_COMBINED: "FC Localization: Combined (Per Word + Per Unit)",
  FC_COPYWRITING: "FC Copywriting",
  NON_FC: "Non FC",
};

export default {
  name: "AssignmentsSection",
  components: {
    CustomDateTimePicker,
    CapacitySection
  },
  props: {
    deliveryDateRefs: {
      required: false
    },
    assignmentFieldSections: {
      type: Object,
      default: () => ({
        shared: [],
        individual: [],
      }),
    },
  },
  data() {
    return {
      showAssignmentsDropdown: false,
      uiRefreshNonce: 0,
      groupByAssignments: "GEO & Request Type",
      groupByOptions: ["GEO & Request Type", "Assignment Detail & Request Type"],
      groupedAssignmentsList: [],
      pricingModel: PRICING_MODEL_OPTIONS.FC_LOCALIZATION_PER_WORD,
      requestType: null,
      geo: null,
      id: null,
      staffDatas: [],
      batchEditDialog: false,
      deadline: false,
      primaryDateTimeMenu: false,
      secondaryDateTimeMenu: false,
      qcDateTimeMenu: false,
      assignmentsList: [],
      manualAssignments: [],
      staffPoolRefreshTimer: null,
      lastStaffPoolRefreshKey: null,
      workflowsFetchNonce: 0,
      prepareAssignmentsNonce: 0,
      staffPool: [],
      workflowsList: [],
      assigneeSectionFields: [
        "primaryAssignee",
        "secondaryAssignee",
        "qcAssignee",
        "individualDeadline",
        "writingDueDate",
        "writingDue",
        "editingDueDate",
        "editingDue",
        "reviewingDueDate",
        "reviewingDue",
        "deliveryDate",
        "deliveryDue",
      ],
      workTypesSectionFields: [
        "workType1Reference",
        "workType2Reference",
        "workType3Reference",
        "workType4Reference",
        "workType5Reference",
        "workType6Reference",
        "workType1Quantity",
        "workType2Quantity",
        "workType3Quantity",
        "workType4Quantity",
        "workType5Quantity",
        "workType6Quantity",
        "characterCount",
      ],
      filedNames: [
        { title: "Assignment Detail", value: "assignmentDetail" },
        { title: "Request Type", value: "requestType" },
        { title: "GEO", value: "geo" },
        { title: "ID", value: "assignmentId" },
        { title: "Work Type 1", value: "workType1Reference" },
        { title: "Work Type 2", value: "workType2Reference" },
        { title: "Work Type 3", value: "workType3Reference" },
        { title: "Work Type 4", value: "workType4Reference" },
        { title: "Work Type 5", value: "workType5Reference" },
        { title: "Work Type 6", value: "workType6Reference" },
        { title: "Work Type 1 Quantity", value: "workType1Quantity" },
        { title: "Work Type 2 Quantity", value: "workType2Quantity" },
        { title: "Work Type 3 Quantity", value: "workType3Quantity" },
        { title: "Work Type 4 Quantity", value: "workType4Quantity" },
        { title: "Work Type 5 Quantity", value: "workType5Quantity" },
        { title: "Work Type 6 Quantity", value: "workType6Quantity" },
        { title: "Character Count", value: "characterCount" },
      ],
      batchEdit: {
        fieldName: "Assignment Detail",
        fieldValue: null,
        value: null
      },
      workType1References: ["CWR_500-60-1100"],
      workType2References: ["CWR_1000-120-1500"],
      workType3References: ["CWR_1500-180-2800"],
      workType4References: ["CWR_2500-300-3800"],
      workType5References: ["CWR_5000-500-7000"],
      workType6References: ["CWR_300-100-500"],
      pricingModelOptions: [
        PRICING_MODEL_OPTIONS.FC_LOCALIZATION_PER_WORD,
        PRICING_MODEL_OPTIONS.FC_LOCALIZATION_PER_UNIT,
        PRICING_MODEL_OPTIONS.FC_LOCALIZATION_COMBINED,
        PRICING_MODEL_OPTIONS.FC_COPYWRITING,
        PRICING_MODEL_OPTIONS.NON_FC
      ],
    };
  },
  watch: {
    async staffAssignments() {
      if (this.staffAssignments) {
        this.syncPricingModelWithUploadFlow();
        await this.prepareAssignments();
        this.scheduleStaffPoolRefresh();
      }
    },
    groupedAssignmentsList: {
      handler() {
        this.$emit("updateAssignmentsList", this.groupedAssignmentsList.flatMap(assignmentItem => assignmentItem.items));
      },
      deep: true,
      immediate: true
    },
    'deliveryDateRefs': {
      async handler() {}
    },
    'formValues.requestDate'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.scheduleStaffPoolRefresh();
      }
    },
    'formValues.deliveryDate'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.scheduleStaffPoolRefresh();
      }
    },
    'formValues.deliveryDue'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.scheduleStaffPoolRefresh();
      }
    },
    "formValues.keyword"(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.applyWorkflowSearchContextChanges();
    },
    "formValues.mediaType"(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.applyWorkflowSearchContextChanges();
    },
    "formValues.genre"(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.applyWorkflowSearchContextChanges();
    },
    "formValues.assignmentTitle"(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.syncSharedFieldToAssignments("assignmentTitle", newValue);
    },
    "formValues.assignmentId"(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.syncSharedFieldToAssignments("assignmentId", newValue);
    },
    "formValues.assignmentDetail"(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.syncSharedFieldToAssignments("assignmentDetail", newValue);
    },
    "formValues.requestType"(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.syncSharedFieldToAssignments("requestType", newValue);
      this.applyWorkflowSearchContextChanges();
    },
    "formValues.geo"(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.syncSharedFieldToAssignments("geo", newValue);
      this.applyWorkflowSearchContextChanges();
    },
    assignmentFieldSections: {
      handler() {
        this.syncSharedFieldConfiguration();
      },
      deep: true,
      immediate: true,
    },
    "formValues.relatedProject": {
      async handler(newProject, oldProject) {
        if (newProject) {
          this.setStaffData();
        }
        const newProjectId = newProject?.id ?? null;
        const oldProjectId = oldProject?.id ?? null;
        if (newProjectId !== oldProjectId) {
          this.lastStaffPoolRefreshKey = null;
          await this.prepareAssignments(newProjectId);
          this.scheduleStaffPoolRefresh();
        }
      },
      immediate: true,
    },
    groupByAssignments() {
      this.grouppingAssignmentsList();
    },
    pricingModel(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.syncLocalizationRateFromPricingModel(newValue);
    },
    "batchEdit.fieldName"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.batchEdit.fieldValue = null;
      }
    },
    applyLocMinRate(newValue, oldValue) {
      if (newValue === oldValue) return;
      if (!this.isFcLocalizationPricingModel) return;

      const nextPricingModel = this.resolveLocalizationPricingModel(newValue);
      if (nextPricingModel && this.pricingModel !== nextPricingModel) {
        this.pricingModel = nextPricingModel;
      }
    }
  },
  computed: {
    ...mapGetters("assignment", [
      "requestTypeOptions",
      "geoOptions",
      "projectsList"
    ]),
    ...mapGetters("spreadsheetUpload", [
      "tableRows",
      "formValues",
      "staffAssignments",
      "backstageCopywriting",
      "backstageLocalization",
      "shakespeare",
      "shakespeareLoc",
      "baseLocalization",
      "cueLoc",
      "cueCopywriting",
      "prepopulationFlow",
      "applyLocMinRate",
    ]),
    selectedBatchField() {
      return this.filedNames.find((field) => field.title === this.batchEdit.fieldName) || null;
    },
    isBatchFieldSelect() {
      return this.batchEdit.fieldName === "Request Type" || this.batchEdit.fieldName === "GEO";
    },
    batchFieldInputType() {
      const selectedFieldKey = this.selectedBatchField?.value || "";
      return /Quantity|characterCount/i.test(selectedFieldKey) ? "number" : "text";
    },
    fieldValues() {
      if (this.batchEdit.fieldName === "Request Type") {
        return this.requestTypeOptions || [];
      } else if (this.batchEdit.fieldName === "GEO") {
        return this.geoOptions || [];
      }
      return [];
    },
    isFcLocalizationPricingModel() {
      return [
        PRICING_MODEL_OPTIONS.FC_LOCALIZATION_PER_WORD,
        PRICING_MODEL_OPTIONS.FC_LOCALIZATION_PER_UNIT,
        PRICING_MODEL_OPTIONS.FC_LOCALIZATION_COMBINED,
      ].includes(this.pricingModel);
    },
    isFcCopywritingPricingModel() {
      return this.pricingModel === PRICING_MODEL_OPTIONS.FC_COPYWRITING;
    },
    isNonFcPricingModel() {
      return this.pricingModel === PRICING_MODEL_OPTIONS.NON_FC;
    },
    allAssignments() {
      return this.groupedAssignmentsList.flatMap((groupItem) => groupItem.items);
    },
    totalAssignmentsCount() {
      return this.allAssignments.length;
    },
  },
  methods: {
    ...mapActions("assignment", [
      "setCommonData",
    ]),
    ...mapActions("spreadsheetUpload", [
      "setApplyLocMinRate",
      "setFormValue",
    ]),
    isFieldShared(fieldKey) {
      return this.assignmentFieldSections?.shared?.includes(fieldKey);
    },
    isFieldIndividual(fieldKey) {
      return this.assignmentFieldSections?.individual?.includes(fieldKey);
    },
    hasMeaningfulValue(value) {
      if (value == null) return false;
      if (typeof value === "string") return value.trim() !== "";
      if (typeof value === "number") return Number.isFinite(value);
      if (typeof value === "object") return Object.keys(value).length > 0;
      return true;
    },
    getSharedFormKey(fieldKey) {
      const keyMap = {
        assignmentTitle: "assignmentTitle",
        assignmentId: "assignmentId",
        assignmentDetail: "assignmentDetail",
        requestType: "requestType",
        geo: "geo",
      };
      return keyMap[fieldKey] || null;
    },
    seedSharedFieldValue(fieldKey) {
      if (!this.isFieldShared(fieldKey)) return;
      const formKey = this.getSharedFormKey(fieldKey);
      if (!formKey) return;
      if (this.hasMeaningfulValue(this.formValues?.[formKey])) return;

      const sampleAssignment = this.assignmentsList.find((assignment) =>
        this.hasMeaningfulValue(assignment?.[fieldKey])
      );
      if (!sampleAssignment) return;

      this.setFormValue({
        key: formKey,
        value: cloneDeep(sampleAssignment[fieldKey]),
      });
    },
    syncSharedFieldToAssignments(fieldKey, incomingValue) {
      if (!this.isFieldShared(fieldKey)) return;
      if (!Array.isArray(this.assignmentsList) || !this.assignmentsList.length) return;

      const formKey = this.getSharedFormKey(fieldKey);
      if (!formKey) return;

      const hasIncomingValue = arguments.length > 1;
      const sharedValue = hasIncomingValue ? incomingValue : this.formValues?.[formKey];
      this.assignmentsList.forEach((assignment) => {
        assignment[fieldKey] = cloneDeep(sharedValue);
      });

      if (fieldKey === "geo" || fieldKey === "requestType" || fieldKey === "assignmentDetail") {
        this.grouppingAssignmentsList();
      }
    },
    syncSharedFieldConfiguration() {
      if (!Array.isArray(this.assignmentsList) || !this.assignmentsList.length) return;

      ["assignmentTitle", "assignmentId", "assignmentDetail", "requestType", "geo"].forEach((fieldKey) => {
        this.seedSharedFieldValue(fieldKey);
        this.syncSharedFieldToAssignments(fieldKey);
      });
    },
    resolveLocalizationPricingModel(locRate) {
      if (locRate === "Per Unit") {
        return PRICING_MODEL_OPTIONS.FC_LOCALIZATION_PER_UNIT;
      }
      if (locRate === "Combined (per word + per unit)") {
        return PRICING_MODEL_OPTIONS.FC_LOCALIZATION_COMBINED;
      }
      return PRICING_MODEL_OPTIONS.FC_LOCALIZATION_PER_WORD;
    },
    normalizeWorkflowContextValue(rawValue) {
      if (rawValue == null) return null;
      if (typeof rawValue === "string") {
        const trimmed = rawValue.trim();
        return trimmed || null;
      }
      if (typeof rawValue === "object") {
        const resolvedValue =
          rawValue.value ??
          rawValue.name ??
          rawValue.label ??
          rawValue.text ??
          rawValue.title ??
          null;
        const trimmed = String(resolvedValue ?? "").trim();
        return trimmed || null;
      }
      const trimmed = String(rawValue).trim();
      return trimmed || null;
    },
    normalizeWorkflowContextComparable(rawValue) {
      const normalizedValue = this.normalizeWorkflowContextValue(rawValue);
      return normalizedValue ? normalizedValue.toLowerCase() : null;
    },
    normalizeSharedKeyword(keywordValue) {
      return this.normalizeWorkflowContextValue(keywordValue);
    },
    syncSharedKeywordToAssignments(keywordValue = this.formValues?.keyword) {
      if (!Array.isArray(this.assignmentsList) || !this.assignmentsList.length) {
        return;
      }
      const normalizedKeyword = this.normalizeSharedKeyword(keywordValue);
      this.assignmentsList.forEach((assignment) => {
        assignment.keyword = normalizedKeyword;
      });
    },
    syncSharedWorkflowFieldsToAssignments({
      mediaType = this.formValues?.mediaType,
      keyword = this.formValues?.keyword,
      genre = this.formValues?.genre,
    } = {}) {
      if (!Array.isArray(this.assignmentsList) || !this.assignmentsList.length) {
        return;
      }

      const normalizedMediaType = this.normalizeWorkflowContextValue(mediaType);
      const normalizedKeyword = this.normalizeSharedKeyword(keyword);
      const normalizedGenre = this.normalizeWorkflowContextValue(genre);

      this.assignmentsList.forEach((assignment) => {
        assignment.mediaType = normalizedMediaType;
        assignment.keyword = normalizedKeyword;
        assignment.genre = normalizedGenre;
      });
    },
    resolveWorkflowForAssignment(assignment) {
      if (!assignment || !Array.isArray(this.workflowsList) || !this.workflowsList.length) {
        return null;
      }

      const geo = this.normalizeWorkflowContextComparable(assignment?.geo);
      const requestType = this.normalizeWorkflowContextComparable(assignment?.requestType);
      const mediaType = this.normalizeWorkflowContextComparable(
        assignment?.mediaType ?? this.formValues?.mediaType
      );
      const keyword = this.normalizeWorkflowContextComparable(
        assignment?.keyword ?? this.formValues?.keyword
      );
      const genre = this.normalizeWorkflowContextComparable(
        assignment?.genre ?? this.formValues?.genre
      );

      const candidates = this.workflowsList.filter((workflow) => {
        const workflowGeo = this.normalizeWorkflowContextComparable(workflow?.geo);
        const workflowRequestType = this.normalizeWorkflowContextComparable(workflow?.requestType);
        if (geo && workflowGeo !== geo) return false;
        if (requestType && workflowRequestType !== requestType) return false;
        return true;
      });

      if (!candidates.length) return null;

      const scopedFields = [
        { key: "mediaType", value: mediaType },
        { key: "keyword", value: keyword },
        { key: "genre", value: genre },
      ].filter(({ value }) => !!value);

      if (!scopedFields.length) return candidates[0];

      const exactMatch = candidates.find((workflow) =>
        scopedFields.every(({ key, value }) =>
          this.normalizeWorkflowContextComparable(workflow?.[key]) === value
        )
      );
      if (exactMatch) return exactMatch;

      let bestMatch = candidates[0];
      let bestScore = -1;
      candidates.forEach((workflow) => {
        const score = scopedFields.reduce((acc, { key, value }) => {
          return acc + (this.normalizeWorkflowContextComparable(workflow?.[key]) === value ? 1 : 0);
        }, 0);
        if (score > bestScore) {
          bestScore = score;
          bestMatch = workflow;
        }
      });

      return bestMatch;
    },
    syncAssignmentsWorkflowSelection() {
      if (!Array.isArray(this.assignmentsList) || !this.assignmentsList.length) return;
      this.assignmentsList.forEach((assignment) => {
        assignment.workflow = this.resolveWorkflowForAssignment(assignment);
      });
    },
    applyWorkflowSearchContextChanges() {
      if (!Array.isArray(this.assignmentsList) || !this.assignmentsList.length) return;
      this.syncSharedWorkflowFieldsToAssignments();
      this.syncAssignmentsWorkflowSelection();
      this.lastStaffPoolRefreshKey = null;
      this.scheduleStaffPoolRefresh();
    },
    handleAssignmentWorkflowCriteriaChange() {
      this.syncAssignmentsWorkflowSelection();
      this.lastStaffPoolRefreshKey = null;
      this.scheduleStaffPoolRefresh();
    },
    resolveDefaultPricingModelByFlow() {
      if (this.backstageCopywriting || this.shakespeare) {
        return PRICING_MODEL_OPTIONS.FC_COPYWRITING;
      }
      if (this.cueCopywriting || this.cueLoc) {
        return PRICING_MODEL_OPTIONS.NON_FC;
      }
      if (
        this.baseLocalization ||
        this.backstageLocalization ||
        this.shakespeareLoc
      ) {
        return this.resolveLocalizationPricingModel(this.applyLocMinRate);
      }
      return this.pricingModel || PRICING_MODEL_OPTIONS.FC_LOCALIZATION_PER_WORD;
    },
    syncPricingModelWithUploadFlow() {
      const nextPricingModel = this.resolveDefaultPricingModelByFlow();
      if (nextPricingModel && this.pricingModel !== nextPricingModel) {
        this.pricingModel = nextPricingModel;
      }
    },
    syncLocalizationRateFromPricingModel(pricingModel) {
      let nextLocalizationRate = null;
      if (pricingModel === PRICING_MODEL_OPTIONS.FC_LOCALIZATION_PER_WORD) {
        nextLocalizationRate = "Per Word";
      } else if (pricingModel === PRICING_MODEL_OPTIONS.FC_LOCALIZATION_PER_UNIT) {
        nextLocalizationRate = "Per Unit";
      } else if (pricingModel === PRICING_MODEL_OPTIONS.FC_LOCALIZATION_COMBINED) {
        nextLocalizationRate = "Combined (per word + per unit)";
      }

      if (nextLocalizationRate && this.applyLocMinRate !== nextLocalizationRate) {
        this.setApplyLocMinRate(nextLocalizationRate);
      }
    },
    nextAssignmentTogglerId() {
      const maxTogglerId = this.assignmentsList.reduce((maxValue, assignment) => {
        const numericId = Number(assignment?.togglerId);
        if (!Number.isFinite(numericId)) return maxValue;
        return Math.max(maxValue, numericId);
      }, -1);
      return maxTogglerId + 1;
    },
    duplicateAssignment(assignmentItem) {
      const sourceIndex = this.assignmentsList.indexOf(assignmentItem);
      if (sourceIndex < 0) return;

      const duplicatedAssignment = cloneDeep(assignmentItem);
      duplicatedAssignment.assignmentId = null;
      duplicatedAssignment.togglerId = this.nextAssignmentTogglerId();
      duplicatedAssignment.togglerState = true;
      duplicatedAssignment.isManual = true;

      this.assignmentsList.splice(sourceIndex + 1, 0, duplicatedAssignment);
      this.manualAssignments.push(duplicatedAssignment);
      this.grouppingAssignmentsList();
    },
    deleteAssignment(assignmentItem) {
      const assignmentIndex = this.assignmentsList.indexOf(assignmentItem);
      if (assignmentIndex < 0) return;

      this.assignmentsList.splice(assignmentIndex, 1);

      const manualAssignmentIndex = this.manualAssignments.findIndex(
        (manualAssignment) => manualAssignment === assignmentItem
          || manualAssignment?.togglerId === assignmentItem?.togglerId
      );
      if (manualAssignmentIndex >= 0) {
        this.manualAssignments.splice(manualAssignmentIndex, 1);
      }

      this.grouppingAssignmentsList();
    },
    normalizeGroupFieldValue(value) {
      return String(value ?? "").trim().toLowerCase();
    },
    getGroupSignature(assignment) {
      if (!assignment || typeof assignment !== "object") return "";

      const requestTypeSignature = this.normalizeGroupFieldValue(assignment.requestType);
      const geoSignature = this.normalizeGroupFieldValue(assignment.geo);
      const assignmentDetailSignature = this.normalizeGroupFieldValue(assignment.assignmentDetail);

      if (this.groupByAssignments === "GEO & Request Type") {
        return `${geoSignature}::${requestTypeSignature}`;
      }
      if (this.groupByAssignments === "Assignment Detail & Request Type") {
        return `${assignmentDetailSignature}::${requestTypeSignature}`;
      }

      return String(assignment.togglerId ?? "");
    },
    getGroupLabel(assignment) {
      if (!assignment || typeof assignment !== "object") return "Unknown group";

      const geoLabel = String(assignment.geo ?? "No GEO").trim() || "No GEO";
      const requestTypeLabel = String(assignment.requestType ?? "No Request Type").trim() || "No Request Type";
      const assignmentDetailLabel = String(assignment.assignmentDetail ?? "No Assignment Detail").trim() || "No Assignment Detail";

      if (this.groupByAssignments === "GEO & Request Type") {
        return `${geoLabel} | ${requestTypeLabel}`;
      }
      if (this.groupByAssignments === "Assignment Detail & Request Type") {
        return `${assignmentDetailLabel} | ${requestTypeLabel}`;
      }

      return geoLabel;
    },
    getAssignmentsForGroup(sourceAssignment) {
      if (!sourceAssignment || !Array.isArray(this.allAssignments)) return [];
      const sourceSignature = this.getGroupSignature(sourceAssignment);
      return this.allAssignments.filter(
        (assignment) => this.getGroupSignature(assignment) === sourceSignature
      );
    },
    getCurrentGroupAssignmentsCount(sourceAssignment) {
      return this.getAssignmentsForGroup(sourceAssignment).length;
    },
    getAssignmentDisplayNumber(assignment) {
      const assignmentIndex = this.allAssignments.findIndex(
        (listItem) => listItem === assignment
      );
      return assignmentIndex >= 0 ? assignmentIndex + 1 : 0;
    },
    resolveAssigneePoolKeyByField(field) {
      if (field === "primaryAssignee") return "primary";
      if (field === "secondaryAssignee") return "secondary";
      if (field === "qcAssignee") return "qc";
      return null;
    },
    resolveAssigneeForTarget(sourceAssignee, targetAssignment, field) {
      const poolKey = this.resolveAssigneePoolKeyByField(field);
      if (!poolKey) return cloneDeep(sourceAssignee);

      const targetPool = targetAssignment?.staffPool?.[poolKey];
      const matchedByName = this.getAssigneeFromPool(sourceAssignee, targetPool);
      if (matchedByName) return matchedByName;

      const sourceAssigneeId = sourceAssignee && typeof sourceAssignee === "object"
        ? sourceAssignee.id ?? sourceAssignee.staffId ?? sourceAssignee.user?.id ?? sourceAssignee.staff?.id ?? null
        : null;
      if (sourceAssigneeId != null && Array.isArray(targetPool)) {
        const matchedById = targetPool.find((poolAssignee) => {
          const targetId = poolAssignee?.id ?? poolAssignee?.staffId ?? poolAssignee?.user?.id ?? poolAssignee?.staff?.id ?? null;
          return targetId != null && String(targetId) === String(sourceAssigneeId);
        });
        if (matchedById) return matchedById;
      }

      return cloneDeep(sourceAssignee);
    },
    refreshAppliedDropdowns() {
      this.uiRefreshNonce += 1;
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    applySectionFieldsToGroup(sourceAssignment, fields = []) {
      this.applySectionFields(
        sourceAssignment,
        this.getAssignmentsForGroup(sourceAssignment),
        fields
      );
    },
    applySectionFields(sourceAssignment, targetAssignments, fields = []) {
      if (!sourceAssignment || !Array.isArray(targetAssignments) || !targetAssignments.length) {
        return;
      }

      targetAssignments.forEach((targetAssignment) => {
        fields.forEach((field) => {
          if (this.resolveAssigneePoolKeyByField(field)) {
            targetAssignment[field] = this.resolveAssigneeForTarget(
              sourceAssignment[field],
              targetAssignment,
              field
            );
            return;
          }
          targetAssignment[field] = cloneDeep(sourceAssignment[field]);
        });
      });

      this.refreshAppliedDropdowns();
    },
    createDefaultStaffPool(geo) {
      const rawStaff = geo
        ? this.staffDatasForGeo(geo)
        : (this.staffDatas || []).map(({ name, disabled, user }) => ({
            name,
            disabled,
            id: user?.id,
            workflow: false,
          }));
      const additionalStaffList = rawStaff.filter(
        (item) => item && typeof item === "object" && item.name
      );
      const withHeader = Array.isArray(additionalStaffList) && additionalStaffList.length
        ? [{ header: "Staff List" }, ...additionalStaffList]
        : [];
      return {
        primary: [...withHeader],
        secondary: [...withHeader],
        qc: [...withHeader],
      };
    },
    createBlankAssignment() {
      const blankAssignment = {
        assignmentTitle: null,
        assignmentDetail: "",
        assignmentId: null,
        requestType: null,
        geo: null,
        mediaType: this.normalizeWorkflowContextValue(this.formValues?.mediaType),
        keyword: this.normalizeWorkflowContextValue(this.formValues?.keyword),
        genre: this.normalizeWorkflowContextValue(this.formValues?.genre),
        workflow: null,
        togglerId: this.assignmentsList.length,
        togglerState: true,
        individualDeadline: false,
        writingDueDate: "",
        writingDue: "",
        editingDueDate: "",
        editingDue: "",
        reviewingDueDate: "",
        reviewingDue: "",
        deliveryDate: null,
        deliveryDue: null,
        taskId: null,
        contentId: null,
        primaryAssignee: null,
        secondaryAssignee: null,
        qcAssignee: null,
        primaryAssigneeBestOption: null,
        secondaryAssigneeBestOption: null,
        qcAssigneeBestOption: null,
        workType1Reference: null,
        workType2Reference: null,
        workType3Reference: null,
        workType4Reference: null,
        workType5Reference: null,
        workType6Reference: null,
        workType1Quantity: null,
        workType2Quantity: null,
        workType3Quantity: null,
        workType4Quantity: null,
        workType5Quantity: null,
        workType6Quantity: null,
        characterCount: null,
        staffPool: this.createDefaultStaffPool(null),
        isManual: true,
      };

      return blankAssignment;
    },
    async addNewAssignment() {
      const newAssignment = this.createBlankAssignment();
      this.manualAssignments.push(newAssignment);
      this.assignmentsList.push(newAssignment);
      this.syncSharedFieldConfiguration();
      this.syncSharedWorkflowFieldsToAssignments();
      this.syncAssignmentsWorkflowSelection();
      this.grouppingAssignmentsList();
      this.lastStaffPoolRefreshKey = null;
      this.scheduleStaffPoolRefresh();
    },
    closeBatchEditDialog() {
      this.batchEditDialog = false;
    },
    normalizeBatchFieldValue(fieldKey, rawValue) {
      if (rawValue == null) return null;

      if (typeof rawValue === "string") {
        const trimmedValue = rawValue.trim();
        if (!trimmedValue) return null;
        if (/Quantity|characterCount/i.test(fieldKey)) {
          const numericValue = Number(trimmedValue);
          return Number.isFinite(numericValue) ? numericValue : null;
        }
        return trimmedValue;
      }

      if (/Quantity|characterCount/i.test(fieldKey)) {
        const numericValue = Number(rawValue);
        return Number.isFinite(numericValue) ? numericValue : null;
      }

      return rawValue;
    },
    applyBatchEdit() {
      const selectedField = this.selectedBatchField;
      if (!selectedField?.value) {
        this.closeBatchEditDialog();
        return;
      }

      const normalizedValue = this.normalizeBatchFieldValue(
        selectedField.value,
        this.batchEdit.fieldValue
      );
      this.allAssignments.forEach((assignment) => {
        this.$set(assignment, selectedField.value, normalizedValue);
      });

      if (selectedField.value === "geo" || selectedField.value === "requestType") {
        this.grouppingAssignmentsList();
        this.syncAssignmentsWorkflowSelection();
        this.lastStaffPoolRefreshKey = null;
        this.scheduleStaffPoolRefresh();
      }

      this.closeBatchEditDialog();
    },
    foldAllGroups() {
      this.groupedAssignmentsList.forEach(assignmentItem => {
        assignmentItem.expanded = false;
      })
      
    console.log("groupedAssignmentsList", this.groupedAssignmentsList);
    },
    unfoldAllGroups() {
      this.groupedAssignmentsList.forEach(assignmentItem => {
        assignmentItem.expanded = true;
      })
    },
    foldAllAssignmentCards() {
      this.groupedAssignmentsList.forEach((groupItem) => {
        groupItem.items.forEach((item) => {
          item.togglerState = false;
        });
      });
    },
    unfoldAllAssignmentCards() {
      this.groupedAssignmentsList.forEach((groupItem) => {
        groupItem.items.forEach((item) => {
          item.togglerState = true;
        });
      });
    },
    assignmentIndividualDateSelected(key, assignmentItem, $event) {
      if (key === 'primary') assignmentItem.writingDueDate = $event;
      if (key === 'secondary') assignmentItem.editingDueDate = $event;
      if (key === 'qc') assignmentItem.reviewingDueDate = $event;
      if (key === 'delivery') assignmentItem.deliveryDate = $event;
    },
    assignmentIndividualTimeSelected(key, assignmentItem, $event) {
      if (key === 'primary') assignmentItem.writingDue = $event;
      if (key === 'secondary') assignmentItem.editingDue = $event;
      if (key === 'qc') assignmentItem.reviewingDue = $event;
      if (key === 'delivery') assignmentItem.deliveryDue = $event;
    },
    normalizeAssigneeName(assignee) {
      if (!assignee) return "";
      if (typeof assignee === "string") return assignee.trim().toLowerCase();
      if (typeof assignee === "object") {
        const fullName = `${assignee?.user?.firstName || ""} ${assignee?.user?.lastName || ""}`.trim();
        return String(assignee?.name || fullName || "").trim().toLowerCase();
      }
      return String(assignee).trim().toLowerCase();
    },
    getAssigneeDisplayName(assignee) {
      if (!assignee) return "";
      if (typeof assignee === "string") return assignee.trim();
      if (typeof assignee === "object") {
        const fullName = `${assignee?.user?.firstName || ""} ${assignee?.user?.lastName || ""}`.trim();
        return String(assignee?.name || fullName || "").trim();
      }
      return String(assignee).trim();
    },
    getAssigneeFromPool(sourceAssignee, staffPool = []) {
      const sourceName = this.normalizeAssigneeName(sourceAssignee);
      if (!sourceName || !Array.isArray(staffPool) || !staffPool.length) return null;
      return (
        staffPool.find((item) => item?.name && this.normalizeAssigneeName(item.name) === sourceName) ||
        null
      );
    },
    prefillAssigneesFromFile(assignment) {
      if (!assignment || typeof assignment !== "object") return;

      const assigneeMap = [
        { targetKey: "primaryAssignee", sourceKeys: ["primary", "writer"], poolKey: "primary" },
        { targetKey: "secondaryAssignee", sourceKeys: ["secondary", "editor"], poolKey: "secondary" },
        { targetKey: "qcAssignee", sourceKeys: ["qa", "qc", "reviewer"], poolKey: "qc" },
      ];

      assigneeMap.forEach(({ targetKey, sourceKeys, poolKey }) => {
        const currentValue = assignment[targetKey];
        const sourceValue = sourceKeys.map((key) => assignment[key]).find((value) => !!value);
        const desiredValue = currentValue || sourceValue;
        if (!desiredValue) return;

        const matchedPoolValue = this.getAssigneeFromPool(
          desiredValue,
          assignment?.staffPool?.[poolKey]
        );
        assignment[targetKey] = matchedPoolValue || desiredValue;
      });
    },
    hasAssigneeWarning(panelItem, assignmentItem) {
      return !!this.autocompleteWarning(panelItem, assignmentItem);
    },
    autocompleteWarning(panelItem, assignmentItem) {
      const selectedAssignee = assignmentItem?.[`${panelItem?.toLowerCase()}Assignee`];
      const bestAssignee = assignmentItem?.[`${panelItem?.toLowerCase()}AssigneeBestOption`];

      const selectedName = this.normalizeAssigneeName(selectedAssignee);
      const bestName = this.normalizeAssigneeName(bestAssignee);

      if (!selectedName || !bestName || selectedName === bestName) return "";

      return `${this.getAssigneeDisplayName(selectedAssignee)} is not the best fit. Recommended: ${this.getAssigneeDisplayName(bestAssignee)}.`;
    },
    getTheBestAssignee(section, staffPool) {
      if (!staffPool || !staffPool.length) return null;
      const level = section?.toUpperCase();
      const staffList = staffPool.filter((item) => item?.name && item?.workflow);

      let candidates = staffList
        .map(item => ({
          ...item,
          availableWords: item.totalAllowedWords - (item.usedWords ?? 0)
        }))
        .filter(item => item.availableWords > 0);

      if (!candidates.length) {
        candidates = staffList;
      }
      if (!candidates.length) return null;

      const levels = ["PRIMARY", "SECONDARY", "QC"];
      const tiers = [1, 2];
      const priorityOrder = {};
      let counter = 1;

      levels.forEach(level => {
        tiers.forEach(tier => {
          priorityOrder[`${level}_TIER_${tier}`] = counter++;
        });
      });

      candidates.sort((a, b) => {
        const rnA = Number.isFinite(Number(a.rn)) ? Number(a.rn) : Number.MAX_SAFE_INTEGER;
        const rnB = Number.isFinite(Number(b.rn)) ? Number(b.rn) : Number.MAX_SAFE_INTEGER;
        if (rnA !== rnB) return rnA - rnB;

        const priA = priorityOrder[a.priority] ?? Number.MAX_SAFE_INTEGER;
        const priB = priorityOrder[b.priority] ?? Number.MAX_SAFE_INTEGER;
        const priDiff = priA - priB;
        if (priDiff !== 0) return priDiff;

        const dateA = Array.isArray(a.lastDeliveryDate)
          ? new Date(a.lastDeliveryDate[0], a.lastDeliveryDate[1] - 1, a.lastDeliveryDate[2])
          : new Date(0);
        const dateB = Array.isArray(b.lastDeliveryDate)
          ? new Date(b.lastDeliveryDate[0], b.lastDeliveryDate[1] - 1, b.lastDeliveryDate[2])
          : new Date(0);
        return dateA - dateB;
      });

      return candidates.find((item) => String(item.priority || "").includes(level)) || candidates[0];
    },
    generalDateTimeFormatter(date, timeAmPm) {
      if (date && timeAmPm) {
        const datePart = new Date(date);
        const day = datePart.getDate();
        const month = datePart.toLocaleString('en', { month: 'short' });
        const year = datePart.getFullYear();
        const time = timeAmPm;
        return `${day} ${month} ${year} (${time})`;
      }
      return '';
    },
    toNullableNumber(value) {
      if (value == null || value === "") return null;
      const numericValue = Number(value);
      return Number.isFinite(numericValue) ? numericValue : null;
    },
    getLocReferencesOptions(i, panelItem) {
      if (i === 1 && this.tableRows && this.tableRows.length) {
        return [iTunesWorkTypeReference[this.tableRows[0].source_geo] && iTunesWorkTypeReference[this.tableRows[0].source_geo][panelItem] ? iTunesWorkTypeReference[this.tableRows[0].source_geo][panelItem] : null].concat(["LOC_2500-00-3800", "LOC_2500-00-4500", "LOC_3500-00-4500", "LOC_300-100-700", "LOC_13-02-26"]);
      } else if (i === 2 && this.tableRows && this.tableRows.length) {
        return ["LOC_300-100-700"]
      } else if (i === 3 && this.tableRows && this.tableRows.length) {
        return [iTunesWorkTypeReference[this.tableRows[0].source_geo] && iTunesWorkTypeReference[this.tableRows[0].source_geo][panelItem] ? iTunesWorkTypeReference[this.tableRows[0].source_geo][panelItem] : null].concat(["LOC_2500-00-3800", "LOC_2500-00-4500", "LOC_3500-00-4500", "LOC_300-100-700", "LOC_13-02-26", "ADP_04-00-06", "ADP_04-00-09"]);
      } else return [];
    },
    getReferencesOptions(i, panelItem) {
      if (i === 1) return this.referencesByRequestType(panelItem);
      else if (i === 4)
        return this.prepopulationFlow === 0
          ? ["CWR_1000-380-3800", "CWR_1500-380-3800"]
          : this.workType4References;
      else return this[`workType${i}References`];
    },
    adaptationMode(panelItem) {
      return this.backstageCopywriting || this.shakespeare
        ? isAdaptation({
            requestType: this.tableRows[0]?.request_type,
            tableRows: this.tableRows,
            shakespeare: this.shakespeare,
            locale: panelItem,
            allLocales: this.tableRows && !this.shakespeare ? this.tableRows[0].geos : this.shakespeare ? this.tableRows.map((el) => el.geo) : [],
            sourceGeo: this.tableRows[0].source_geo
          })
        : false;
    },
    referencesByRequestType(panelItem) {
      console.log("this.adaptationMode(panelItem)",panelItem);
      return this.adaptationMode(panelItem)
        ? [
            getFCWorkType({
              locale: panelItem,
              allLocales: this.tableRows ? this.tableRows[0].geos : [],
              workType1: true,
              sourceGeo: this.tableRows[0].source_geo,
              requestType: this.tableRows[0]?.request_type,
              tableRows: this.tableRows,
              shakespeare: this.shakespeare,
              backstageCopywriting: this.backstageCopywriting
            }),
          ]
        : this.workType1References;
    },
    adaptationMode(panelItem) {
      return this.backstageCopywriting || this.shakespeare
        ? isAdaptation({
            requestType: this.tableRows[0]?.request_type,
            tableRows: this.tableRows,
            shakespeare: this.shakespeare,
            locale: panelItem,
            allLocales: this.tableRows && !this.shakespeare ? this.tableRows[0].geos : this.shakespeare ? this.tableRows.map((el) => el.geo) : [],
            sourceGeo: this.tableRows[0].source_geo
          })
        : false;
    },
    onDeadlineChange(event, item) {
        item.writingDueDate = this.formValues.writingDueDate;
        item.writingDue = this.formValues.writingDue;
        item.editingDueDate = this.formValues.editingDueDate;
        item.editingDue = this.formValues.editingDue;
        item.reviewingDueDate = this.formValues.reviewingDueDate;
        item.reviewingDue = this.formValues.reviewingDue;
        item.deliveryDate = this.formValues.deliveryDate;
        item.deliveryDue = this.formValues.deliveryDue;
    },
    handleValueSelectChange(ref, v, assignmentItem) {
      assignmentItem[ref] = v;
      // Word count edits map to workType1Quantity. Wait 3 seconds before
      // sending a new workflow request with the updated value.
      if (ref === "workType1Quantity") {
        this.scheduleStaffPoolRefresh({ delay: 3000 });
      }
    },
    onPrimaryDateSelected(date) {
      this.setFormValue({ key: 'writingDueDate', value: date });
    },
    onPrimaryTimeSelected(timeAmPm) {
      this.setFormValue({ key: 'writingDue', value: timeAmPm });
    },
    onSecondaryDateSelected(date) {
      this.setFormValue({ key: 'editingDueDate', value: date });
    },
    onSecondaryTimeSelected(timeAmPm) {
      this.setFormValue({ key: 'editingDue', value: timeAmPm });
    },
    onQCDateSelected(date) {
      this.setFormValue({ key: 'qcDueDate', value: date });
    },
    onQCTimeSelected(timeAmPm) {
      this.setFormValue({ key: 'qcDue', value: timeAmPm });
    },
    handleDropdowns() {
      Promise.all([
        getEnum("RequestType"),
        getEnum("GEO")
      ])
        .then((resp) => {
          this.setCommonData({ field: "requestTypeOptions", data: resp[0] });
          this.setCommonData({ field: "geoOptions", data: resp[1] });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async getWorkflowsData(projectId = this.formValues?.relatedProject?.id) {
      if (!projectId) {
        this.workflowsList = [];
        return [];
      }
      const requestNonce = ++this.workflowsFetchNonce;
      const resp = await getWorkflofsByProject(projectId);
      const isLatestRequest = requestNonce === this.workflowsFetchNonce;
      const isCurrentProject = projectId === (this.formValues?.relatedProject?.id ?? null);
      if (!isLatestRequest || !isCurrentProject) {
        return [];
      }
      this.workflowsList = Array.isArray(resp?.data) ? resp.data : [];
      return this.workflowsList;
    },
    async getStaffPool() {
      const activeProjectId = this.formValues?.relatedProject?.id ?? null;
      this.syncSharedWorkflowFieldsToAssignments();
      this.syncAssignmentsWorkflowSelection();
      // startDate is the request date; if it is empty no requests should be sent.
      if (!this.formValues?.requestDate) {
        return;
      }
      const requests = this.assignmentsList.map((assignment) => {
        const mediaType = this.normalizeWorkflowContextValue(this.formValues?.mediaType);
        const keyword = this.normalizeWorkflowContextValue(this.formValues?.keyword);
        const genre = this.normalizeWorkflowContextValue(this.formValues?.genre);
        return getStaffWithWorkflows({
          workflowId: assignment?.workflow?.id,
          geo: assignment?.geo,
          mediaType,
          keyword,
          genre,
          requestType: assignment?.requestType,
          projectId: activeProjectId ?? assignment?.workflow?.projectId,
          dueDate: this.formValues.defaultDeliveryDate,
          startDate: this.formValues.requestDate,
          wordCount: this.resolveAssignmentWordCount(assignment)
        });
      });
      
      try {
        const responses = await Promise.all(requests);
        this.assignmentsList.forEach((assignment, index) => {
          assignment.staffPool = {};

          ["PRIMARY", "SECONDARY", "QC"].forEach((level) => {
            const priorityOrder = {
              [`${level}_TIER_1`]: 1,
              [`${level}_TIER_2`]: 2,
            };

            const tierGroups = { 1: [], 2: [] };

            const prefix = level === "PRIMARY" ? "P" : level === "SECONDARY" ? "S" : "Q";

            responses[index]?.data?.rankedStaffs?.forEach((staff) => {
              staff.workflow = true;
              if (staff.lastDeliveryDate?.length) {
                const lastDate = `${staff.lastDeliveryDate[0]}-${staff.lastDeliveryDate[1]}-${staff.lastDeliveryDate[2]}`;
                const startDate = new Date(lastDate);
                const currentDate = new Date();
                const timeDifference = currentDate - startDate;
                staff.lastDeliveryDaysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
              } else {
                staff.lastDeliveryDaysAgo = null;
              }

              if (staff.priority.includes(level)) {
                const tier = priorityOrder[staff.priority];
                if (tier) {
                  tierGroups[tier].push(staff);
                }
              }
            });

            tierGroups[1].sort((a, b) => priorityOrder[a.priority] - priorityOrder[b.priority]);
            tierGroups[2].sort((a, b) => priorityOrder[a.priority] - priorityOrder[b.priority]);

            const dropdownList = [];

            if (tierGroups[1].length) {
              dropdownList.push({ header: `${prefix}1` }, ...tierGroups[1]);
            }
            if (tierGroups[2].length) {
              dropdownList.push({ header: `${prefix}2` }, ...tierGroups[2]);
            }
            const additionalStaffList = this.staffDatasForGeo(assignment.geo);
            if (additionalStaffList.length) {
              dropdownList.push({ header: "Staff List" }, ...additionalStaffList);
            }
            assignment.staffPool[level.toLowerCase()] = dropdownList;
          });
        });

        this.assignmentsList.forEach((assignment) => {
          this.prefillAssigneesFromFile(assignment);

          ["PRIMARY", "SECONDARY", "QC"].forEach((level) => {
            const bestOption = this.getTheBestAssignee(
              level.toLowerCase(),
              assignment?.staffPool?.[level.toLowerCase()]
            );
            assignment[`${level.toLowerCase()}AssigneeBestOption`] = bestOption;
          });

          if (!assignment.primaryAssignee && assignment.primaryAssigneeBestOption) {
            assignment.primaryAssignee = assignment.primaryAssigneeBestOption;
          }
        });

      } catch (error) {
        console.error('Error fetching staff pool:', error);
      }
    },
    setStaffData() {
      this.staffDatas = this.formValues.relatedProject.staff
        .map((el) => ({
          ...el,
          disabled: false,
          geos: el.adminDetails.geos,
          initials: el.adminDetails.initials,
          name: `${el.user.firstName} ${el.user.lastName}`,
          slackID: el.adminDetails.slackIdFc,
          cueSlackID: el.adminDetails.slackIdStaff,
        }))
        .sort((a, b) => a.user.firstName.localeCompare(b.user.firstName));

      this.assignmentsList.forEach((assignment) => {
        const hasRecommendationData = ["primary", "secondary", "qc"].some((level) =>
          Array.isArray(assignment?.staffPool?.[level]) &&
          assignment.staffPool[level].some((item) => item?.workflow)
        );
        if (!hasRecommendationData) {
          assignment.staffPool = this.createDefaultStaffPool(assignment?.geo || null);
        }
        this.prefillAssigneesFromFile(assignment);
      });
    },
    staffDatasForGeo(geoItem) {
      if (!this.staffDatas) return ["none"];
      const retVal = this.staffDatas
        .filter((el) => el.geos.includes(geoItem))
        .map(({ name, disabled, user }) => {
          return { name, disabled, id: user.id, workflow: false };
        });

      return retVal;
    },
    async prepareAssignments(projectId = this.formValues?.relatedProject?.id) {
      const callNonce = ++this.prepareAssignmentsNonce;
      this.assignmentsList = [];
      console.log("this.staffAssignments", this.staffAssignments);
      console.log("this.tableRows", this.tableRows);
      const targetProjectId = projectId ?? null;
      await this.getWorkflowsData(targetProjectId);
      if (callNonce !== this.prepareAssignmentsNonce) {
        return;
      }
      if (targetProjectId !== (this.formValues?.relatedProject?.id ?? null)) {
        return;
      }
      this.staffAssignments && Object.keys(this.staffAssignments).forEach((key) => {
        if (this.backstageCopywriting) {
          Object.keys(this.staffAssignments[key]).forEach((key2) => {
            key2 !== "wordCount" && this.assignmentsList.push({
              ...this.staffAssignments[key][key2],
              workflow: this.workflowsList.find((el) => el.geo === key2 && el.requestType === this.formValues.requestType 
                ? this.formValues.requestType 
                : this.tableRows[0].request_type
                  ? this.tableRows[0].request_type
                  : "Copywriting"),
              geo: key2,
              togglerId: this.assignmentsList.length,
              togglerState: false,
              individualDeadline: false,
              writingDueDate: '',
              writingDue: '',
              requestType: this.formValues.requestType 
                ? this.formValues.requestType 
                : this.tableRows[0].request_type
                  ? this.tableRows[0].request_type
                  : "Copywriting",
            });
          })
        } else if (this.shakespeareLoc) {
          Object.keys(this.staffAssignments[key]).forEach((key2) => {
            key2 !== "wordCount" && this.assignmentsList.push({
              ...this.staffAssignments[key][key2],
              workflow: this.workflowsList.find((el) => el.geo === key2 && el.requestType === this.formValues.requestType 
                ? this.formValues.requestType 
                : this.tableRows[0].request_type
                  ? this.tableRows[0].request_type
                  : "Localization"),
              geo: key2,
              togglerId: this.assignmentsList.length,
              togglerState: false,
              individualDeadline: false,
              writingDueDate: '',
              writingDue: '',
              taskId: this.tableRows.find(el => el.geo === key2)?.task_id,
              requestType: this.formValues.requestType 
                ? this.formValues.requestType 
                : this.tableRows[0].request_type
                  ? this.tableRows[0].request_type
                  : "Localization",
            });
          })
        } else if (this.cueLoc) {
          const sourceRowForTask =
            (this.tableRows || []).find((row) => row?.task_name === key) || null;
          const defaultWorkType =
            this.formValues?.workType ??
            sourceRowForTask?.workType ??
            sourceRowForTask?.work_type ??
            null;
          const defaultWordCount = this.toNullableNumber(
            this.staffAssignments[key]?.wordCount ??
            sourceRowForTask?.word_count ??
            sourceRowForTask?.quantity
          );
          Object.keys(this.staffAssignments[key]).forEach((key2) => {
            key2 !== "wordCount" && key2 !== "assignmentTitle" && this.assignmentsList.push({
              ...this.staffAssignments[key][key2],
              workflow: this.workflowsList.find((el) => el.geo === key2 && el.requestType === this.formValues.requestType 
                ? this.formValues.requestType 
                : this.tableRows[0].request_type
                  ? this.tableRows[0].request_type
                  : "Localization"),
              geo: key2,
              togglerId: this.assignmentsList.length,
              togglerState: false,
              individualDeadline: false,
              assignmentDetail: key,
              requestType: this.formValues.requestType 
                ? this.formValues.requestType 
                : this.tableRows[0].request_type
                  ? this.tableRows[0].request_type
                  : "Localization",
              workType1Reference:
                this.staffAssignments[key][key2]?.workType1Reference != null &&
                this.staffAssignments[key][key2]?.workType1Reference !== ""
                  ? this.staffAssignments[key][key2].workType1Reference
                  : defaultWorkType,
              workType1Quantity:
                this.staffAssignments[key][key2]?.workType1Quantity != null
                  ? this.toNullableNumber(this.staffAssignments[key][key2].workType1Quantity)
                  : defaultWordCount,
              wordCount: defaultWordCount,
            });
          })
        } else if (this.baseLocalization) {
          Object.keys(this.staffAssignments[key]).forEach((key2) => {
            if (key2 === "wordCount") return;
            const assignmentItem = {
              ...this.staffAssignments[key][key2],
              workflow: this.workflowsList.find((el) => el.geo === key2 && el.requestType === this.formValues.requestType
                ? this.formValues.requestType
                : this.tableRows[0].request_type
                  ? this.tableRows[0].request_type
                  : "Localization"),
              geo: key2,
              togglerId: this.assignmentsList.length,
              togglerState: false,
              individualDeadline: false,
              writingDueDate: '',
              writingDue: '',
              primaryAssignee: null,
              assignmentDetail: key,
              requestType: this.formValues.requestType
                ? this.formValues.requestType
                : this.tableRows[0].request_type
                  ? this.tableRows[0].request_type
                  : "Localization",
            };
            this.applyBaseLocalizationWorkTypeDefaults(
              assignmentItem,
              this.staffAssignments[key]?.wordCount
            );
            this.assignmentsList.push(assignmentItem);
          })
        } else if (this.shakespeare) {
          Object.keys(this.staffAssignments[key]).forEach((key2) => {
            if (key2 === "content_id" || key2 === "task_name") return;
            const sourceRow = this.tableRows.find((el) => el.geo === key2) || {};
            const sourceAssignmentId = sourceRow.content_id ?? sourceRow.video_content_id ?? null;
            this.assignmentsList.push({
              ...this.staffAssignments[key][key2],
              workflow: this.workflowsList.find((el) => el.geo === key2 && el.requestType === this.formValues.requestType 
                ? this.formValues.requestType 
                : this.tableRows[0].request_type
                  ? this.tableRows[0].request_type
                  : "Localization"),
              geo: key2,
              togglerId: this.assignmentsList.length,
              togglerState: false,
              individualDeadline: false,
              assignmentDetail: this.staffAssignments[key].task_name,
              taskId: sourceRow.task_id ?? null,
              assignmentId: sourceAssignmentId,
              contentId: sourceAssignmentId,
              keyword: sourceRow.keyword ?? null,
              id: key,
              requestType: this.formValues.requestType 
                ? this.formValues.requestType 
                : this.tableRows[0].request_type
                  ? this.tableRows[0].request_type
                  : "Localization",
            });
          })
        } else if (this.backstageLocalization) {
          Object.keys(this.staffAssignments[key]).forEach((key2) => {
            console.log("backstageLocalization",key, key2, this.staffAssignments[key][key2])
            key2 !== "wordCount" && this.assignmentsList.push({
              ...this.staffAssignments[key][key2],
              workflow: this.workflowsList.find((el) => el.geo === key2 && el.requestType === this.formValues.requestType 
                ? this.formValues.requestType 
                : this.tableRows[0].request_type
                  ? this.tableRows[0].request_type
                  : "Localization"),
              geo: key2,
              togglerId: this.assignmentsList.length,
              togglerState: false,
              individualDeadline: false,
              writingDueDate: '',
              writingDue: '',
              primaryAssignee: null,
              assignmentDetail: key,
              requestType: this.formValues.requestType 
                ? this.formValues.requestType 
                : this.tableRows[0].request_type
                  ? this.tableRows[0].request_type
                  : "Localization",
            });
          })
        }
      })
      if (this.cueCopywriting) {
        this.tableRows.forEach((el) => {
          const resolvedRequestType = this.formValues.requestType
            ? this.formValues.requestType
            : el.requestType
              ? el.requestType
              : el.request_type
                ? el.request_type
                : this.tableRows[0].request_type
                  ? this.tableRows[0].request_type
                  : "Copywriting";
          this.assignmentsList.push({
            ...el,
            workflow: this.workflowsList.find((el) => el.geo === el.source_geo && el.requestType === this.formValues.requestType 
                ? this.formValues.requestType 
                : this.tableRows[0].request_type
                  ? this.tableRows[0].request_type
                  : "Localization"),
            togglerId: this.assignmentsList.length,
            togglerState: false,
            individualDeadline: false,
            assignmentDetail:
              el.assignmentDetail ??
              el.assignment_detail ??
              el.task_name ??
              "",
            requestType: resolvedRequestType,
            assignmentId: el.assignmentId ?? el.assignment_id ?? el.task_id ?? null,
            taskId: el.taskId ?? el.task_id ?? null,
            contentId: el.contentId ?? el.content_id ?? null,
            workType1Reference:
              el.workType1Reference ??
              el.workType ??
              el.work_type ??
              null,
            workType1Quantity:
              el.workType1Quantity != null
                ? el.workType1Quantity
                : el.quantity != null
                  ? el.quantity
                  : null,
          });
        })
      }

      if (this.manualAssignments.length) {
        this.manualAssignments.forEach((manualAssignment) => {
          manualAssignment.togglerId = this.assignmentsList.length;
          this.assignmentsList.push(manualAssignment);
        });
      }

      this.assignmentsList.forEach((assignment) => {
        const hasStaffPool =
          assignment?.staffPool &&
          typeof assignment.staffPool === "object" &&
          Object.keys(assignment.staffPool).length > 0;
        if (!hasStaffPool) {
          assignment.staffPool = this.createDefaultStaffPool(assignment?.geo || null);
        }
        this.prefillAssigneesFromFile(assignment);
      });
      this.syncSharedFieldConfiguration();
      this.syncSharedWorkflowFieldsToAssignments();
      this.syncAssignmentsWorkflowSelection();

      console.log("this.prepareAssignments", this.assignmentsList);
      this.grouppingAssignmentsList();
    },
    grouppingAssignmentsList() {
      if (!this.assignmentsList || !this.assignmentsList.length) {
        this.groupedAssignmentsList = [];
        return [];
      }

      const expandedByGroupKey = new Map(
        (this.groupedAssignmentsList || []).map((groupItem) => [groupItem.key, groupItem.expanded])
      );
      const groups = this.assignmentsList.reduce((acc, item) => {
        const key = this.getGroupSignature(item);
        const label = this.getGroupLabel(item);
        if (!acc[key]) {
          acc[key] = {
            key,
            label,
            items: [],
            expanded: expandedByGroupKey.get(key) ?? false,
          };
        }
        acc[key].items.push(item);
        return acc;
      }, {});
      console.log("groups", Object.values(groups), groups);
      this.groupedAssignmentsList = Object.values(groups);
    },
    getLocReferencesOptions(i, panelItem) {
      if (i === 1 && this.tableRows && this.tableRows.length) {
        return [iTunesWorkTypeReference[this.tableRows[0].source_geo] && iTunesWorkTypeReference[this.tableRows[0].source_geo][panelItem] ? iTunesWorkTypeReference[this.tableRows[0].source_geo][panelItem] : null].concat(["LOC_2500-00-3800", "LOC_2500-00-4500", "LOC_3500-00-4500", "LOC_300-100-700", "LOC_13-02-26"]);
      } else if (i === 2 && this.tableRows && this.tableRows.length) {
        return ["LOC_300-100-700"]
      } else if (i === 3 && this.tableRows && this.tableRows.length) {
        return [iTunesWorkTypeReference[this.tableRows[0].source_geo] && iTunesWorkTypeReference[this.tableRows[0].source_geo][panelItem] ? iTunesWorkTypeReference[this.tableRows[0].source_geo][panelItem] : null].concat(["LOC_2500-00-3800", "LOC_2500-00-4500", "LOC_3500-00-4500", "LOC_300-100-700", "LOC_13-02-26", "ADP_04-00-06", "ADP_04-00-09"]);
      } else return [];
    },
    isBaseLocalizationAdaptation(locale) {
      return this.baseLocalization && locale
        ? isAdaptation({
            requestType: this.tableRows?.[0]?.request_type,
            locale,
            allLocales: this.tableRows?.[0]?.geos || [],
            sourceGeo: this.tableRows?.[0]?.source_geo,
          })
        : false;
    },
    getBaseLocalizationDefaultWorkType1(locale) {
      const adaptationWorkTypes = {
        "de-CH": "ADP_04-00-09",
        "en-AU": "ADP_04-00-06",
        "en-GB": "ADP_04-00-06",
        "en-CA": "ADP_04-00-06",
      };

      if (this.isBaseLocalizationAdaptation(locale)) {
        return adaptationWorkTypes[locale] || null;
      }

      if (this.applyLocMinRate === "Per Unit") {
        return "LOC_300-100-700";
      }

      return iTunesWorkTypeReference?.[this.tableRows?.[0]?.source_geo]?.[locale] || null;
    },
    applyBaseLocalizationWorkTypeDefaults(assignment, baseWordCount) {
      if (!this.baseLocalization || !assignment) return;
      if (assignment.isManual) return;

      const locale = assignment.geo;
      const isAdaptationTask = this.isBaseLocalizationAdaptation(locale);
      const locMode = this.applyLocMinRate || "Per Word";
      const defaultWordCount = baseWordCount ?? assignment.wordCount ?? null;

      assignment.workType1Reference = assignment.workType1Reference || this.getBaseLocalizationDefaultWorkType1(locale);
      assignment.workType2Reference =
        assignment.workType2Reference ||
        (locMode === "Combined (per word + per unit)" && !isAdaptationTask
          ? "LOC_300-100-700"
          : null);

      if ((isAdaptationTask || locMode !== "Per Unit") && assignment.workType1Quantity == null) {
        assignment.workType1Quantity = defaultWordCount;
      }
      if ((isAdaptationTask || locMode === "Per Word") && assignment.workType2Quantity == null) {
        assignment.workType2Quantity = null;
      }
      if (assignment.wordCount == null && defaultWordCount != null) {
        assignment.wordCount = defaultWordCount;
      }
    },
    resolveAssignmentWordCount(assignment) {
      // Word count sent with each workflow request. The editable "Word Count"
      // input maps to workType1Quantity, so prefer it; fall back to the
      // assignment's wordCount, and send 0 when neither is present.
      if (!assignment || typeof assignment !== "object") return 0;
      const quantity = Number(assignment.workType1Quantity);
      if (Number.isFinite(quantity) && quantity > 0) return quantity;
      const wordCount = Number(assignment.wordCount);
      if (Number.isFinite(wordCount) && wordCount > 0) return wordCount;
      return 0;
    },
    getAssignmentsWorkflowCriteriaSignature() {
      if (!Array.isArray(this.assignmentsList) || !this.assignmentsList.length) return "";
      return this.assignmentsList
        .map((assignment) => {
          return [
            this.normalizeWorkflowContextComparable(assignment?.geo) || "",
            this.normalizeWorkflowContextComparable(assignment?.requestType) || "",
            assignment?.workflow?.id ?? "",
            this.resolveAssignmentWordCount(assignment),
          ].join("~");
        })
        .join("||");
    },
    canRefreshStaffPool() {
      return !!(
        this.formValues?.relatedProject?.id &&
        this.formValues?.requestDate &&
        this.formValues?.deliveryDate &&
        this.formValues?.deliveryDue &&
        Array.isArray(this.assignmentsList) &&
        this.assignmentsList.length
      );
    },
    scheduleStaffPoolRefresh({ rebuildAssignments = false, delay = 150 } = {}) {
      clearTimeout(this.staffPoolRefreshTimer);
      this.staffPoolRefreshTimer = setTimeout(async () => {
        if (!this.canRefreshStaffPool()) return;
        const refreshKey = [
          this.formValues?.relatedProject?.id,
          this.formValues?.requestDate,
          this.formValues?.deliveryDate,
          this.formValues?.deliveryDue,
          this.normalizeWorkflowContextComparable(this.formValues?.mediaType) || "",
          this.normalizeWorkflowContextComparable(this.formValues?.keyword) || "",
          this.normalizeWorkflowContextComparable(this.formValues?.genre) || "",
          this.getAssignmentsWorkflowCriteriaSignature(),
        ].join("|");
        if (this.lastStaffPoolRefreshKey === refreshKey) return;
        this.lastStaffPoolRefreshKey = refreshKey;
        if (rebuildAssignments) {
          await this.prepareAssignments();
        }
        await this.getStaffPool();
      }, delay);
    },
    getWorkTypeValue(assignment, panelItem) {
      const keyItem = assignment?.[panelItem];
      const locale = assignment?.geo;

      if (!panelItem?.includes("workType")) {
        return keyItem;
      }

      if (this.shakespeare) {
        const adaptation = isAdaptation({
          locale,
          allLocales: this.tableRows ? this.tableRows.map((el) => el.geo) : [],
          tableRows: this.tableRows,
          shakespeare: this.shakespeare,
        });

        if (!adaptation) return keyItem;
        if (panelItem !== "workType1Reference") return "";

        return getFCWorkType({
          requestType: this.tableRows?.[0]?.request_type,
          locale,
          allLocales: this.tableRows ? this.tableRows.map((el) => el.geo) : [],
          shakespeare: this.shakespeare,
          tableRows: this.tableRows,
        });
      }

      if (this.backstageCopywriting) {
        const adaptation = isAdaptation({
          requestType: this.tableRows?.[0]?.request_type,
          tableRows: this.tableRows,
          shakespeare: this.shakespeare,
          locale,
          allLocales: this.tableRows && !this.shakespeare ? this.tableRows[0].geos : [],
          sourceGeo: this.tableRows?.[0]?.source_geo,
        });

        if (!adaptation) return keyItem;
        if (panelItem !== "workType1Reference") return "";

        return getFCWorkType({
          locale,
          allLocales: this.tableRows ? this.tableRows[0].geos : [],
          workType1: true,
          sourceGeo: this.tableRows?.[0]?.source_geo,
          requestType: this.tableRows?.[0]?.request_type,
          tableRows: this.tableRows,
          shakespeare: this.shakespeare,
          backstageCopywriting: this.backstageCopywriting,
        });
      }

      if (this.baseLocalization) {
        this.applyBaseLocalizationWorkTypeDefaults(assignment, assignment?.wordCount);
        return assignment?.[panelItem] ?? null;
      }

      return keyItem;
    }
  },
  mounted() {
    this.syncPricingModelWithUploadFlow();
    this.handleDropdowns();
  }
};
</script>

<style scoped lang="scss">
.assignments-section {
  h4 {
    font-family: Roboto;
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    letter-spacing: 0%;
    margin: 15px 0;
  }
  & .assignments__summ {
    border-radius: 4px;
    padding: 12px;
    font-family: Roboto;
    font-weight: 400;
    font-size: 28px;
    background-color: #EFEFEF;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 66px;
    height: 56px;
  }
}

.assignments__dropdown-button {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  border: 1px solid #E0E4EB;
  background-color: #f5f5f5;
}

.wtMenuList__item {
  cursor: pointer;
}

.clickable-row {
  cursor: pointer;
}

.group {
  background-color: #EFEFEF;
  border-radius: 10px;
  padding: 0 20px;
  margin-bottom: 20px;
  &__summ {
    min-width: 35px;
    border-radius: 8px;
    padding-right: 12px;
    padding-left: 12px;
    background-color: #fff;
    text-align: center;
  }
  &__geo {
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-size: 22px;
    color: #000;
  }
  &__dropdown-button {
    font-size: 25px;
    color: #000;
  }
}

.assignment-container {
  box-shadow: 0px 2px 4px 0px #00000040;
  background-color: #fff;
  border-radius: 15px;
  padding: 20px;
  min-height: 50px;
  margin-bottom: 6px;
}

.assignment-item {
  border-radius: 15px;
  padding: 20px;
  background-color: #fff;
  &__title {
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-size: 18px;
    color: #606060;
  }
}
.assignees__dropdown-button {
  width: 42px;
  height: 20px;
  border-radius: 8px;
  padding: 2.5px;
  border: 1px solid #E0E4EB;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.assignee-input-wrapper {
  position: relative;
}

.assignee-warning-overlay {
  position: absolute;
  right: 39px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 4;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.assignee-warning-icon {
  width: 18px;
  height: 18px;
  display: block;
  cursor: pointer;
}

.flex {
  display: flex !important;
}

.fade-slide-enter-active, .fade-slide-leave-active {
  transition: all 0.5s ease;
  max-height: 1000px;
  opacity: 1;
}

.fade-slide-enter, .fade-slide-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

.rotated {
  transform: rotate(180deg);
  transition: transform 0.5s ease;
}

.p-10px {
  padding: 15px 20px;
}

.dialog-card {
  padding: 25px;
}
</style>
